<template>
  <v-btn disable @click="toggleJourneyOrStoryView()" icon small>
    <v-icon v-if="!isToggleJourneyView">mdi-transit-connection-variant</v-icon>
    <v-icon v-else>mdi-cellphone-text</v-icon>
  </v-btn>
</template>
<script>

export default {
  name: 'toggleJourneyView',
  components: {},
  props: {

  },
  data() {
    return {}
  },

  computed: {
    isToggleJourneyView: {
      get: function () {
        return this.$store.getters.getIsJourneyOrSingleStory;
      }
    }
  },

  methods: {
    toggleJourneyOrStoryView() {
      this.$store.dispatch("setIsJourneyOrSingleStory", !this.isToggleJourneyView)
    }
  }
};
</script>

<style>

</style>